<template>
   <nav
      id="ff-navbar"
      class="navbar navbar-expand-md navbar-light bg-transparent ff-blue font-non-codensed py-0"
      :class="breakpoint">
      <div class="container">
         <a
            href="/"
            class="navbar-brand d-inline-flex align-items-center gap-2">
            <img
               v-bind="imgAttributes"
               src="/wp-content/themes/findforsikring_2015-sommer/images/graphics/findforsikring.svg"
               style="margin-bottom: 5px"
               alt="Findforsikring logo" />
         </a>
         <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#nav-collapse"
            aria-controls="nav-collapse"
            aria-expanded="false"
            aria-label="Toggle navigation">
            <span class="navbar-toggler-icon" />
         </button>
         <div
            id="nav-collapse"
            class="collapse navbar-collapse">
            <!-- Right aligned nav items -->
            <ul class="navbar-nav ms-auto gap-2 gap-md-3 gap-xl-4 gap-xxl-5">
               <li class="nav-item">
                  <a
                     id="login_btn"
                     class="nav-link"
                     href="https://bruger.findforsikring.dk">
                     <div class="d-flex align-items-end justify-content-center gap-1">
                        <div class="rasmus-icon lock" />
                        <div class="h4 m-0 fw-semibold">Log&nbsp;ind</div>
                     </div>
                  </a>
               </li>
               <li class="nav-item">
                  <a
                     href="https://www.find-erhvervsforsikring.dk"
                     class="nav-link">
                     <div class="d-flex align-items-end justify-content-center gap-1">
                        <div class="rasmus-icon factory" />
                        <div class="h4 m-0 fw-semibold">Erhverv</div>
                     </div>
                  </a>
               </li>
<!--               <li class="nav-item">-->
<!--                  <a-->
<!--                     href="#"-->
<!--                     data-bs-toggle="modal"-->
<!--                     data-bs-target="#call-me-modal"-->
<!--                     class="nav-link">-->
<!--                     <div class="d-flex align-items-end justify-content-center gap-1">-->
<!--                        <div class="rasmus-icon phone" />-->
<!--                        <div class="h4 m-0 fw-semibold">86518000</div>-->
<!--                     </div>-->
<!--                  </a>-->
<!--               </li>-->
            </ul>
         </div>
      </div>
   </nav>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
   name: 'FindforsikringHeaderOld',
   computed: {
      ...mapGetters(['width']),
      imgAttributes() {
         let imgWidth = 269;
         if (this.width < 354) {
            imgWidth = this.width - 21 /* padding */ - 14 /* margin */ - 50 /* button */;
         }
         return {
            width: imgWidth,
            height: 35,
         };
      },
   },
};
</script>

<style lang="scss" scoped>
header {
   background-color: rgba(203, 220, 226, 0.1);
}
#ff-navbar {
   min-height: 60px;
   font-weight: 500;
   a.nav-link * {
      color: var(--ff-dark-blue);
      display: flex;
      align-items: flex-end;
      line-height: 16px;
   }

   .nav-link {
      span {
         white-space: nowrap;
      }
   }
}
</style>
